import { withInstall } from "../utils/index.mjs";
import _Tabbar from "./Tabbar.mjs";
const Tabbar = withInstall(_Tabbar);
var stdin_default = Tabbar;
import { tabbarProps } from "./Tabbar.mjs";
export {
  Tabbar,
  stdin_default as default,
  tabbarProps
};
